import { render, staticRenderFns } from "./ReqMateList.vue?vue&type=template&id=d2bb4266&scoped=true"
import script from "./ReqMateList.vue?vue&type=script&lang=js"
export * from "./ReqMateList.vue?vue&type=script&lang=js"
import style0 from "./ReqMateList.vue?vue&type=style&index=0&id=d2bb4266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb4266",
  null
  
)

export default component.exports